import { render, staticRenderFns } from "./BlockListQuoteCustom.vue?vue&type=template&id=0ce78d3e&"
import script from "./BlockListQuoteCustom.vue?vue&type=script&lang=js&"
export * from "./BlockListQuoteCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports